import { useEffect, useRef, useState } from 'react';
import type { RequestStateQuery } from '../../../../../@types/RequestStateQuery';
import useSearchBranchesAdmin, {
  type AdminBranchSearch,
} from '../../../../../data/admin/useSearchBranchesAdmin';
import useAuth from '../../../../../hooks/useAuth';

const useSearchAdminBranches = (
  search?: string,
): [AdminBranchSearch[] | undefined, RequestStateQuery, string] => {
  const { isAdmin } = useAuth();
  const [query, setQuery] = useState('');
  const timeout = useRef<NodeJS.Timeout>(undefined);

  const [list, request] = useSearchBranchesAdmin(query);

  useEffect(() => {
    if (isAdmin) {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        if (search) {
          setQuery(search);
        }
      }, 200);
    }
  }, [search, isAdmin]);

  return [list, request, query];
};

export default useSearchAdminBranches;
